import { render, staticRenderFns } from "./IndexArchive.vue?vue&type=template&id=eb03b0f4&"
import script from "./IndexArchive.vue?vue&type=script&lang=js&"
export * from "./IndexArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports